<!-- Derived from Lucide (https://lucide.dev), ISC License; portions from Feather, MIT. See LICENSE in this folder. -->
<!-- Both leaves solid; the stem and ground stay strokes. -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M14 9V7a4 4 0 0 1 4-4h1.5a.5.5 0 0 1 .5.5V5a4 4 0 0 1-4 4zM4 9a5 5 0 0 1 8 4 5 5 0 0 1-8-4z"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M16 9a4 4 0 0 0-4 4c0 2 1 3 1 5a5 5 0 0 1-1 3M5 21h14"
    />
  </svg>
</template>
